{
  "name": "tidal-embed-player",
  "version": "0.0.1",
  "packageManager": "pnpm@10.34.5",
  "description": "TIDAL Embed Player with Serverless AWS Lambda rendering",
  "type": "module",
  "engines": {
    "node": "24.21.0"
  },
  "browserslist": [
    "defaults",
    "not op_mini all"
  ],
  "scripts": {
    "start": "run-s build prod:start:server",
    "dev": "run-s build dev:start:server",
    "prod:start:server": "LAMBDA_TASK_ROOT=true AWS_EXECUTION_ENV=true AWS_ENV=fakelamda pnpm run start:server",
    "dev:start:server": "NODE_ENV=development LAMBDA_TASK_ROOT=false AWS_EXECUTION_ENV=false pnpm run start:server",
    "start:server": "node --env-file=.env src/server/local/index.js",
    "lint:css": "stylelint \"src/client/**/*.css\"",
    "lint:js": "eslint \"src/server/**/*.js\" --quiet && eslint \"src/client/**/*.js\" --quiet",
    "typecheck": "tsc",
    "esbuild:client": "node --env-file=.env scripts/esbuild-client.js",
    "esbuild:server": "node --env-file=.env scripts/esbuild-server.js",
    "hasher": "node scripts/hasher.js",
    "build": "NODE_ENV=production run-s esbuild:client hasher esbuild:server",
    "test": "web-test-runner \"src/**/*.test.js\" --node-resolve",
    "cypress:run": "npx cypress run --browser chrome --headless",
    "cypress:open": "cypress open",
    "gh-action:build": "node scripts/esbuild-client.js && node scripts/hasher.js && node scripts/esbuild-server.js",
    "gh-action:start": "LAMBDA_TASK_ROOT=true AWS_EXECUTION_ENV=true AWS_ENV=fakelamda node src/server/local/index.js"
  },
  "devDependencies": {
    "@tidal-music/auth": "1.6.2",
    "@tidal-music/common": "0.2.1",
    "@tidal-music/event-producer": "2.4.2",
    "@tidal-music/player": "0.20.1",
    "@tidal-music/player-web-components": "0.3.0",
    "@types/mocha": "^10.0.10",
    "@types/node": "^24.13.4",
    "@web/test-runner": "^1.0.0",
    "@web/test-runner-playwright": "^1.0.0",
    "chai": "^6.2.2",
    "cypress": "^15.21.1",
    "esbuild": "^0.28.2",
    "esbuild-plugin-clean": "^1.0.1",
    "esbuild-plugin-copy": "^2.1.1",
    "esbuild-postcss": "^0.0.4",
    "eslint": "9.39.5",
    "eslint-config-tidal": "4.0.0",
    "eslint-plugin-compat": "^6.2.1",
    "eslint-plugin-cypress": "^5.3.0",
    "express": "^5.2.1",
    "hasha": "^7.0.0",
    "husky": "^9.1.7",
    "lint-staged": "^16.4.0",
    "npm-run-all2": "^8.0.4",
    "platform": "1.3.6",
    "playwright": "1.63.0",
    "postcss": "^8.5.28",
    "postcss-flexbugs-fixes": "^5.0.2",
    "postcss-preset-env": "^10.6.1",
    "postcss-reporter": "^7.1.0",
    "screenfull": "^6.0.2",
    "stylelint": "^16.25.0",
    "stylelint-config-standard": "^39.0.1",
    "svgo": "^4.1.0",
    "typescript": "^5.9.3"
  }
}
